<template>
  <div class="pageBox pageBox-role zzlContainer">
    <div class="zzlCover">
      <div class="zzlTitle">
        角色管理
      </div>
      <div class="contents moduleTwo" v-show="isModule === 'moduleTwo'">
        <div class="zzlSearch">
          <div class="leftSearch"></div>
          <div class="rightSearch">
            <div class="fr">
              <el-button size="medium" round class="zzlPrimary" @click.prevent="addRole">添加角色</el-button>
            </div>
          </div>
        </div>
        <div class="zzlTableList">
          <el-table :data="roleTableData" stripe border>
            <el-table-column prop="name" label="角色名" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <div style="padding:0 10px;" v-html="scope.row.name"></div>
              </template>
            </el-table-column>
            <el-table-column prop="description" label="角色描述" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <div style="padding:0 10px;" v-html="scope.row.description"></div>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" align="center" min-width="50">
              <template slot-scope="scope">
                <span style="margin-right: 35px;" @click="roleHandleCommonEdit(scope.row, scope.$index)">编辑</span>
                <span @click="roleHandleCommonDelete(scope.row, scope.$index)">删除</span>
                <div>
                  <i
                    class="zzl_icons zion-write"
                    @click="roleHandleCommonEdit(scope.row, scope.$index)"
                    title="编辑"
                  ></i>
                  <i
                    class="zzl_icons zion-delete"
                    @click="roleHandleCommonDelete(scope.row, scope.$index)"
                    title="删除"
                  ></i>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="rolesizeChange"
            @current-change="roleCurrentChange"
            :current-page="table.pageNum"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="table.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="count"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!--添加修改role的模态框-->
    <section>
      <el-dialog
        :title="roleUpdateOrAddNum === 1 ? '添加角色' : '修改角色'"
        :visible.sync="roleModal"
        append-to-body
        center
        width="590px"
        top="15vh"
        custom-class="zzlDialog"
        @close="closeRoleModal"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        >
        <div class="addOrUpdate">
          <el-form
            :model="roleForm"
            label-position="top"
            ref="roleFormRef"
            :rules="roleRules"
            >
            <el-row>
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <div class="inputItem">
                  <el-form-item prop="name" label="角色名称:">
                    <el-input size="medium" v-model="roleForm.name" maxlength="30" placeholder="请输入用户名"></el-input>
                  </el-form-item>
                  <span class="smTip">（角色名为必填项，不能为空）</span>
                </div>
              </el-col>
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <div class="inputItem">
                  <el-form-item prop="description" label="角色描述:">
                    <el-input
                      type="textarea"
                      size="medium"
                      maxlength="30"
                      v-model="roleForm.description"
                      placeholder="请输入备注"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <div class="inputItem">
                  <el-form-item  label="权限控制">
                    <div class="authorizationBox">
                      <el-tree
                        :key="'tree' + new Date().getTime()"
                        :data="treeData1"
                        show-checkbox
                        node-key="RightName"
                        ref="tree"
                        :default-checked-keys="defaultChecked"
                        :default-expanded-keys="defaultExpanded"
                        :props="defaultProps"
                        @check="treeChange"
                        @node-expand="nodeExpand"
                        @node-collapse="nodeCollapse"
                      ></el-tree>
                      <el-tree
                        :key="'tree2' + new Date().getTime()"
                        :data="treeData2"
                        show-checkbox
                        node-key="Id"
                        ref="tree2"
                        :default-checked-keys="defaultChecked2"
                        :default-expanded-keys="defaultExpanded2"
                        :props="defaultProps2"
                        @check="treeChange2"
                        @node-expand="nodeExpand2"
                        @node-collapse="nodeCollapse2"
                      ></el-tree>
                    </div>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="medium" round @click.prevent="roleModal=false">取消</el-button>
          <el-button size="medium" round class="zzlPrimary" @click="addOrUpdateRole('roleFormRef')">提 交</el-button>
        </span>
      </el-dialog>
    </section>
  </div>
</template>

<script>
import hashes from "../../../static/js/hashes.min";
import { setTimeout } from "timers";
export default {
  name: "RoleManagement",
  data() {
    return {
      kw: "", //搜索值
      isModule: "moduleTwo",
      roleTableData: [
        { name: "1" }
      ], // table的data
      count: 0, // 一共多少条
      table: {
        order: 'created_time',
        by: 1,
        pageNum: 1, // 当前页码
        pageSize: 10, // 每页多少条
      },
      roleModal: false, // 添加修改Role的模态框
      roleUpdateOrAddNum: -1, // 添加是1，修改是2
      roleForm: {
        name: "",
        description: ""
      }, // 角色的form
      roleRules: {
        name: [{ required: true, message: "不能为空", trigger: "blur" }],
        description: [{ required: true, message: "不能为空", trigger: "blur" }]
      }, // 角色的form规则
      roleOptions: [], // 角色选择的选项
      // treeData1:  [{
      //   Checked:false,
      //   Items:[],
      //   RightName:"permissions",
      //   RightTypes:[],
      //   Title:"系统权限"
      // }],
      treeData1: [
        {
          Checked: false,
          Group: true,
          Items: [],
          RightName: "permissions",
          RightTypes: [],
          Title: "系统权限"
        }
      ],
      treeData2: [
        {
          Checked: false,
          IsFolder: true,
          Id: "navgation",
          Title: "系统导航",
          Children: []
        }
      ],
      defaultProps: {
        children: "Items",
        label: "Title"
      },
      defaultProps2: {
        children: "Children",
        label: "Title"
      },

      roleName: "admin",
      id: "",
      defaultChecked: [], // 默认选中
      defaultExpanded: [],
      defaultChecked2: [], // 默认选中
      defaultExpanded2: [],
      permissionsParams: {}, // 权限参数
      isChange: false
    };
  },
  methods: {
    // 展开tree
    nodeExpand (data, node, tree) {
      this.defaultExpanded.push(data.RightName);
    },
    // 展开tree2
    nodeExpand2 (data, node, tree) {
      this.defaultExpanded2.push(data.Id);
    },
    // 关闭tree公共函数
    filterExpanded(expanded, arr){
      function filter(expanded, arr){
        if(expanded.length > 0){
          for(let i = 0; i < expanded.length; i++){
            for(let item of arr){
              if(expanded[i] == item.key){
                expanded.splice(i, 1);
              }
              if(item.childNodes.length > 0){
                filter(expanded, item.childNodes);
              }
            }
            
          }
        }
      }
      filter(expanded, arr);
    },
    // 关闭tree
    nodeCollapse (data, node, tree) {
      this.filterExpanded(this.defaultExpanded, [node]);
    },
    // 关闭tree2
    nodeCollapse2 (data, node, tree) {
      this.filterExpanded(this.defaultExpanded2, [node]);
    },
    // 树权限改变
    async treeChange(data, checked) {
      if (checked.checkedKeys.length === 0) {
        this.permissionsParams.rights = [];
        this.defaultChecked=[];  //避免表单change时 tree ui不勾选
        return;
      }
      setTimeout(()=>{
        this.defaultChecked=checked.checkedKeys;  //避免表单change时 tree ui不勾选
      },0);
      let filterRights = [];
      let rights = [];
      for (let item of checked.checkedNodes) {
        if (!item.Group) {
          filterRights.push({
            id: item.RightName.split('0')[0],
            rights: [item.RightName.split('|')[1]]
          });
        }
      }
      rights.push(filterRights[0]);
      let i = 0;
      for (let item of filterRights) {
        if (item.id != rights[i].id) {
          rights.push(item);
          i++;
        } else {
          rights[i].rights.push(item.rights[0]);
        }
      }
      rights[0].rights.shift();
      this.permissionsParams.rights = rights;
    },
    async treeChange2(data, checked) {
      if (checked.checkedKeys.length > 0) {
        let arr = [];
        for (let item of checked.checkedKeys) {
          arr.push({ id: item, rights: ["A"] });
        }

        let arr3 = checked.halfCheckedKeys;
        for (let i = 0; i < arr3.length; i++) {
          if (arr3[i]!='navigation'&&arr3[i]!='navgation') {
            arr.push({ id: arr3[i], rights: ["A"] })
          }
        }

        this.permissionsParams.navigation = arr;
        this.defaultChecked2=checked.checkedKeys  //避免表单change时 tree ui不勾选
      } else {
        this.defaultChecked2=[];  //避免表单change时 tree ui不勾选
        this.permissionsParams.navigation = [];
      }
    },
    // 点击表格上的修改
    async roleHandleCommonEdit(_data, _num) {
      this.roleName = _data.name;
      this.id = _data.id;
      await this.getNavTree();
      this.roleModal = true;
      this.roleUpdateOrAddNum = 2;
      setTimeout(() => {
        this.$refs["roleFormRef"].resetFields();
        this.roleForm.name = _data.name;
        this.roleForm.description = _data.description;
        let refs = this.$refs.tree;
        let refs2 = this.$refs.tree2;
        refs.setCheckedKeys([]);
        refs2.setCheckedKeys([]);
        this.defaultChecked = [];
        this.defaultChecked2 = [];
        let arr = [];
        let arr2 = [];
        function filterTree(data, arr) {
          for (let i = 0; i < data.length; i++) {
            if (data[i].Checked) {
              arr.push({
                RightName: data[i].RightName,
                Title: data[i].Title,
                Group: data[i].Group
              });
            }
            if (data[i].Items && data[i].Items.length > 0) {
              filterTree(data[i].Items, arr);
            }
          }
        }
        function filterTree2(data, arr) {
          for (let i = 0; i < data.length; i++) {
            if (data[i].Checked) {
              arr.push({
                Title: data[i].Title,
                Id: data[i].Id,
                IsFolder: data[i].IsFolder
              });
            }
            if (data[i].Children && data[i].Children.length > 0) {
              filterTree2(data[i].Children, arr);
            }
          }
        }
        filterTree(refs.data, arr);
        filterTree2(refs2.data, arr2);

        for (let i = 0; i < arr.length; i++) {
          this.defaultChecked.push(arr[i].RightName);
          refs.setCheckedKeys([arr[i].RightName]);
        }
        for (let i = 0; i < arr2.length; i++) {
          if (!arr2[i].IsFolder) {
            this.defaultChecked2.push(arr2[i].Id);
            refs2.setCheckedKeys([arr2[i].Id]);
          }
        }
        let filterRights = [];
        let rights = [];
        for (let item of arr) {
          if (!item.Group) {
            filterRights.push({
              id: item.RightName.split('0')[0],
              rights: [item.RightName.split('|')[1]]
            });
          }
        }

        if (filterRights.length > 0) {
          rights.push(filterRights[0]);

          let i = 0;
          for (let item of filterRights) {
            if (item.id != rights[i].id) {
              rights.push(item);
              i++;
            } else {
              rights[i].rights.push(item.rights[0]);
            }
          }
          rights[0].rights.shift();
        }

        let filterArr2 = [];
        if (arr2.length > 0) {
          for (let item of arr2) {
            filterArr2.push({ id: item.Id, rights: ["A"] });
          }
          this.permissionsParams.navigation = filterArr2;
        } else {
          this.permissionsParams.navigation = [];
        }
        this.permissionsParams = {
          rights,
          navigation: filterArr2
        };
      }, 0);
    },
    // 添加或修改角色 (提交表单时
    addOrUpdateRole(formname) {
      this.$refs[formname].validate(async valid => {
        if (valid) {
          if (this.roleUpdateOrAddNum === 1) {
            //添加
            let params = {
              id: this.id,
              name: this.roleForm.name,
              description: this.roleForm.description,
              rights: this.permissionsParams
            };
            const res = await this.zzlHttp.post(this.zzlApi.addRole, params);
            if (res.code === 0) {
              await this.getRoleTableData();
              this.$refs["roleFormRef"].resetFields();
              this.roleModal = false;
              this.$message.success("添加成功");
              this.defaultExpanded = [];
              this.defaultExpanded2 = [];
            }else {
              this.$message.error(res.msg);
            }
          }
          if (this.roleUpdateOrAddNum === 2) {
            //修改
            let params = {
              id: this.id,
              name: this.roleForm.name,
              description: this.roleForm.description,
              rights: this.permissionsParams
            };
            const res = await this.zzlHttp.post(this.zzlApi.updateRole, params);
            if (res.code === 0) {
              await this.getRoleTableData();
              this.$refs["roleFormRef"].resetFields();
              this.roleModal = false;
              this.$message.success("修改成功");
              this.defaultExpanded = [];
              this.defaultExpanded2 = [];
            }else {
              this.$message.error("修改失败");
            }
          }
        }
      });
    },
    // 重置
    reset(_refname) {
      // if (_refname === "roleFormRef") {
      //   setTimeout(() => {
      //     this.$refs.tree.setCheckedNodes([]);
      //   });
      // }
      // this.$refs[_refname].resetFields();
    },
    // 关闭模态框
    closeRoleModal() {
      this.$refs["roleFormRef"].resetFields();
      this.roleModal = false;
      this.$refs.tree.setCheckedNodes([]);
      this.defaultExpanded = [];
      this.defaultExpanded2 = [];
    },
    // 添加
    async addRole() {
      this.defaultChecked = [];
      await this.getNavTree();
      this.roleModal = true;
      setTimeout(() => {
        this.$refs["roleFormRef"].resetFields();
        let refs = this.$refs.tree;
        let refs2 = this.$refs.tree2;
        refs.setCheckedKeys([]);
        refs2.setCheckedKeys([]);
        this.defaultChecked = [];
        this.defaultChecked2 = [];
      }, 0);
      this.roleUpdateOrAddNum = 1;
      this.permissionsParams = {
        rights: [],
        navigation: []
      };
    },

    // 删除
    async roleHandleCommonDelete(_data, _num) {
      
      this.$confirm("您正在执行删除操作", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
          closeOnClickModal: false,
          closeOnPressEscape: false,
        type: "warning"
      })
        .then(async () => {
          const res = await this.zzlHttp.post(
            this.zzlApi.deleteRole,
            {id:_data.id}
          );
          if (res.code === 0) {
            this.roleTableData.splice(_num, 1);
            this.count = this.count - 1;
            this.$message.success("删除成功");
          } else {
            this.$message.error("删除失败");
          }
        })
        .catch(() => {});
    },

    // 页码改变
    roleCurrentChange(val) {
      this.table.pageNum = val;
      this.getRoleTableData();
    },
    // 每页多少条改变
    rolesizeChange(val) {
      this.table.pageNum = 1;
      this.table.pageSize = val;
      this.getRoleTableData();
    },
    // 搜索角色
    async searchRole() {
      this.table.pageNum = 1;
      await this.getRoleTableData();
    },
    // 获取表格数据
    async getRoleTableData() {
      const loading = this.$loading({
        lock: true,
        text: "系统正在努力加载,请耐心等待",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let params = {
        ...this.table,
        kw: this.kw,
        total: true
      };
      const res = await this.zzlHttp.post(this.zzlApi.getRoleList, params);
      if (res.code === 0) {
        this.count = res.data.count || 0;
        this.roleTableData = res.data.list || [];
      } else {
        this.count = 0;
        this.roleTableData = [];
      }
      loading.close();
    },
    // 获取角色列表
    async getRole() {
      const res = await this.zzlHttp.post(this.zzlApi.getRole);
      if (res.code === 0) {
        this.roleOptions = res.data;
      }
    },
    // 获取导航树
    async getNavTree() {
      const res = await this.zzlHttp.post(this.zzlApi.getNavTree, {
        navname: "main",
        name: this.roleName
      });
      if (res.code === 0) {
        this.treeData1[0].Items = res.data.rights.Items;
        this.treeData2[0].Children = res.data.navigation;
      }
    }
  },
  async mounted() {
    const loading = this.$loading({
      lock: true,
      text: "系统正在努力加载,请耐心等待",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)"
    });
    await this.getRoleTableData();
    loading.close();
  }
};
</script>

<style scoped lang="scss">
.iconBox {
  .operation {
    button {
      margin: 10px 10px 10px 0;
    }
  }
  .title {
    padding: 14px 18px;
    background-color: #f8f8f8;
    border-bottom: solid 1px #e6e6e6;
    margin-bottom: 28px;
    i {
      font-size: 12px;
    }
  }
  ul {
    overflow: hidden;
    list-style: none;
    padding: 0;
    margin: 0 28px;
    border: 1px solid #eaeefb;
    border-radius: 4px;
    li {
      float: left;
      width: 12.5%;
      text-align: center;
      height: 120px;
      line-height: 120px;
      color: #666;
      font-size: 13px;
      transition: color 0.15s linear;
      border-right: 1px solid #eee;
      border-bottom: 1px solid #eee;
      margin-right: -1px;
      margin-bottom: -1px;
      cursor: pointer;
      span {
        display: inline-block;
        line-height: normal;
        vertical-align: middle;
        font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
          Microsoft YaHei, SimSun, sans-serif;
        color: #99a9bf;
        i {
          display: block;
          font-size: 32px;
          margin-bottom: 15px;
          color: #606266;
        }
      }
      .icon-name {
        display: inline-block;
        padding: 0 3px;
        height: 1em;
        color: #606266;
      }
    }
    li:hover,
    li:focus {
      color: #fff;
      background-color: #6adac5;
      border-color: #07c29e;
      i {
        color: #fff;
      }
      .icon-name {
        color: #fff;
      }
    }
    li.active {
      color: #fff;
      background-color: #6adac5;
      border-color: #07c29e;
      i {
        color: #fff;
      }
      .icon-name {
        color: #fff;
      }
    }
  }
}
.inputItem {
  position: relative;
  padding-right: 12px;
  .authorizationBox {
    width: 100%;
    height: 285px;
    padding: 8px 12px;
    overflow: auto;
    border: solid 1px #e6e6e6;
  }
  span.smTip {
    position: absolute;
    top: 0px;
    left: 74px;
    font-size: 12px;
    color: #bcc0c4;
  }
  span.selectAll {
    position: absolute;
    top: 11px;
    right: 12px;
    font-size: 12px;
    text-decoration: underline;
    color: #07c29e;
    cursor: pointer;
  }
}
.addOrUpdate {
  .title {
    padding: 13px 20px 12px;
    background-color: #f8f8f8;
    border-bottom: solid 1px #e6e6e6;
    font-size: 14px;
    font-weight: bold;
    line-height: 14px;
    color: #45494d;
    i {
      font-size: 12px;
    }
    i:hover {
      color: #07c29e;
      cursor: pointer;
    }
  }
  .formBox {
    padding: 20px;
  }
  .operation {
    padding: 0 20px 22px;
    button {
      margin-left: 12px;
    }
  }
}
.margin21 {
  margin-top: 21px;
}
.pageBox {
  .titleButton {
    padding: 12px 17px 0;
    border-bottom: 1px solid #e6e6e6;
    margin-bottom: 20px;
    line-height: 23px;
    color: #07c29e;
    span {
      padding: 0 8px 6px;
      border-bottom: 3px solid transparent;
      margin-right: 20px;
      color: #555a5e;
      cursor: pointer;
      i {
        font-size: 16px;
        margin-right: 8px;
      }
    }
    span.active {
      color: #07c29e;
      border-bottom-color: #07c29e;
    }
  }
  .contents {
    min-height: calc(100vh - 148px);
    .tableList {
      overflow: auto;
      i {
        font-size: 16px;
        margin-right: 28px;
        &:last-child {
          margin-right: 0;
        }
        &:hover {
          color: #07c29e;
        }
      }
    }
  }
  
}
</style>
